import { apply, put, delay } from 'redux-saga/effects';

import {
  loadOrdersSucceeded,
  loadOrdersFailed,
  loadOrders,
  loadLocationSucceeded,
} from '../reducers/signage.reducers';

// eslint-disable-next-line import/prefer-default-export

export function* loadLocation(signageApi, { payload }) {

  try {
    const { locationId } = payload;

    const response = yield apply(
      signageApi,
      signageApi.loadLocation,
      [locationId]
    );

    if (response && !response.errorCode) {
      yield put(loadLocationSucceeded({ location: response }));
    }
  } catch (error) {

  }
}

export function* loadSignageOrders(signageApi, { payload }) {
  if (!payload) {
    yield put(loadOrdersFailed({ message: 'Failed load signage orders' }));
  }

  const { locationId, skipReschedule } = payload;
  try {
    const response = yield apply(
      signageApi,
      signageApi.loadOrdersForSignage,
      [locationId]
    );

    if (response.errorCode) {
      yield put(loadOrdersFailed({ message: response.message || 'Failed load signage orders' }));

      if (!skipReschedule) {
        yield delay(150000);
        yield put(loadOrders({ locationId, skipReschedule }));
      }      
    } else {
      yield put(loadOrdersSucceeded({ signage: response }));

      if (!skipReschedule) {
        yield delay(45000);
        yield put(loadOrders({ locationId, skipReschedule }));
      }
    }
  } catch (e) {
    yield put(loadOrdersFailed({ message: 'Failed load signage orders' }));

    if (!skipReschedule) {
      yield delay(150000);
      yield put(loadOrders({ locationId, skipReschedule }));
    }
  }
}
